// `/meetings/recordings` is the Recordings tab of the Meetings page (owner: meeting-recorder, owner feedback F15).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/meetings/recordings/')({
  beforeLoad: () => {
    throw redirect({ to: '/meetings', search: { tab: 'recordings' }, replace: true });
  },
});
